/**
 * Language selector dropdown for content language
 */

import { languageOptions } from "./constants";

export function LanguageSelector({ value, onChange }) {
  return (
    <div className="card-base p-6">
      <label className="text-sm text-viraly-muted mb-3 block">Content Language</label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="input-base w-full"
        data-testid="language-selector"
      >
        {languageOptions.map((lang) => (
          <option key={lang.id} value={lang.id}>
            {lang.flag} {lang.name}
          </option>
        ))}
      </select>
    </div>
  );
}
